import React from 'react';
import { Platform } from 'react-native';
import { ActivityType } from 'fitbeat.gym-core';
import FunctionalCardioIcon from '../assets/icons/activity-types/functional-cardio.svg';
import FunctionalStrengthIcon from '../assets/icons/activity-types/functional-strength.svg';
import FunctionalPilatesIcon from '../assets/icons/activity-types/functional-pilates.svg';
import BoxingIcon from '../assets/icons/boxing-area-icon.svg';
import PowerstationIcon from '../assets/icons/activity-types/power-station.svg';
import BikeStudioIcon from '../assets/icons/activity-types/bike-fitillion.svg';
import StepIcon from '../assets/icons/step-area-icon.svg';
import RunningIcon from '../assets/icons/activity-types/running.svg';
import TreadmillIcon from '../assets/icons/treadmill-icon.svg';
import ClimbingIcon from '../assets/icons/activity-types/climbing.svg';
import PilatesAndYogaIcon from '../assets/icons/activity-types/pilates-and-yoga.svg';
import EllipticalIcon from '../assets/icons/elliptical-area-icon.svg';
import CyclingIcon from '../assets/icons/activity-types/cycling.svg';
import BenchAndDumbbellIcon from '../assets/images/bench-and-dumbbells.svg';
import OtherCardioIcon from '../assets/icons/activity-types/other-cardio.svg';
import RowerIcon from '../assets/icons/rower-area-icon.svg';
import MultiSportIcon from '../assets/icons/activity-types/multi-sport.svg';
import GymnasticsIcon from '../assets/icons/activity-types/gymnastics.svg';
import WinterSportsIcon from '../assets/icons/activity-types/winter-sports.svg';
import WalkingAndHikingIcon from '../assets/icons/activity-types/walking-and-hiking.svg';
import RaquetSportIcon from '../assets/icons/activity-types/raquet-sport.svg';
import TeamSportsIcon from '../assets/icons/activity-types/team-sports.svg';
import DanceAndAerobicsIcon from '../assets/icons/activity-types/dance-and-aerobics.svg';
import CombatAndMartialArtsIcon from '../assets/icons/activity-types/combat-and-martial-arts.svg';
import Theme from '../theme';

const typeIconSize = Platform.OS === 'web' ? 34 : 30;

const iconWithStyle = (
  Icon: React.ComponentType<React.SVGProps<SVGSVGElement>>,
  fill?: string,
  typeIconSizeCustom?: number,
) => {
  const iconFill = fill || Theme.CHARCOAL;
  const iconSize = typeIconSizeCustom || typeIconSize;
  return <Icon fill={iconFill} width={iconSize} height={iconSize} />;
};

export function getActivityTypeIcon(
  activityType: ActivityType,
  fill?: string,
  typeIconSizeCustom?: number,
) {
  const iconFill = fill || Theme.CHARCOAL;
  const iconSize = typeIconSizeCustom || typeIconSize;
  const ActivityTypeIconMap = {
    [ActivityType.BuildFitillion]: iconWithStyle(FunctionalStrengthIcon, iconFill, iconSize),
    [ActivityType.BurnFitillion]: iconWithStyle(FunctionalCardioIcon, iconFill, iconSize),
    [ActivityType.BalanceFitillion]: iconWithStyle(FunctionalPilatesIcon, iconFill, iconSize),
    [ActivityType.BoxingFitillion]: iconWithStyle(BoxingIcon, iconFill, iconSize),
    [ActivityType.PowerStationFitillion]: iconWithStyle(PowerstationIcon, iconFill, iconSize),
    [ActivityType.TreadmillFitillion]: iconWithStyle(TreadmillIcon, iconFill, iconSize),
    [ActivityType.StudioBikeFitillion]: iconWithStyle(BikeStudioIcon, iconFill, iconSize),
    // imported
    [ActivityType.Stepper]: iconWithStyle(StepIcon, iconFill, iconSize),
    [ActivityType.Running]: iconWithStyle(RunningIcon, iconFill, iconSize),
    [ActivityType.Climbing]: iconWithStyle(ClimbingIcon, iconFill, iconSize),
    [ActivityType.PilatesAndYoga]: iconWithStyle(PilatesAndYogaIcon, iconFill, iconSize),
    [ActivityType.Elliptical]: iconWithStyle(EllipticalIcon, iconFill, iconSize),
    [ActivityType.Cycling]: iconWithStyle(CyclingIcon, iconFill, iconSize),
    [ActivityType.StrengthTraining]: iconWithStyle(BenchAndDumbbellIcon, iconFill, iconSize),
    [ActivityType.OtherCardio]: iconWithStyle(OtherCardioIcon, iconFill, iconSize),
    [ActivityType.Swimming]: iconWithStyle(RowerIcon, iconFill, iconSize),
    [ActivityType.Multisport]: iconWithStyle(MultiSportIcon, iconFill, iconSize),
    [ActivityType.HIIT]: iconWithStyle(FunctionalCardioIcon, iconFill, iconSize),
    [ActivityType.Gymnastics]: iconWithStyle(GymnasticsIcon, iconFill, iconSize),
    [ActivityType.WinterSports]: iconWithStyle(WinterSportsIcon, iconFill, iconSize),
    [ActivityType.WalkingAndHiking]: iconWithStyle(WalkingAndHikingIcon, iconFill, iconSize),
    [ActivityType.RacquetSport]: iconWithStyle(RaquetSportIcon, iconFill, iconSize),
    [ActivityType.RowingAndPaddling]: iconWithStyle(RowerIcon, iconFill, iconSize),
    [ActivityType.TeamSports]: iconWithStyle(TeamSportsIcon, iconFill, iconSize),
    [ActivityType.DanceAndAerobics]: iconWithStyle(DanceAndAerobicsIcon, iconFill, iconSize),
    [ActivityType.CombatAndMartialArts]: iconWithStyle(CombatAndMartialArtsIcon, iconFill, iconSize),
  };

  return ActivityTypeIconMap[activityType];
}
